module.exports = __webpack_public_path__ + "static/img/bt.ea6504ab.png";